module.exports = __webpack_public_path__ + "img/bahaodirupin_xy.0affc0cc.png";